// extracted by mini-css-extract-plugin
export default {"words":"About_words__QQMCs","about":"About_about__tFYRZ","textBox":"About_textBox__ch8Xr","tittle":"About_tittle__93lT3","img":"About_img__ThOzN"};